import React, { useEffect, useState } from 'react';
import MuxPlayer from '@mux/mux-player-react';
import { API_SOCIAL } from '../../../constants/api';
import request from '../../../utils/api';
import Subtitle from '../../core/Subtitle/index';

const EventPlayer3 = () => {
  const [items, setItems] = useState([]);
  useEffect(() => {
    request(`${API_SOCIAL}widget/home`, {
      params: '',
      method: 'GET'
    }).then(response => {
      const filteredItems = response
        .filter(
          el =>
            el.type === 'player' ||
            el.type === 'player3' ||
            el.type === 'player5'
        )
        .map(el => ({
          imagen: el.icon,
          logo: el.logo,
          url: el.url
        }));

      setItems(filteredItems);
    });
  }, []);
  return (
    <div>
      {items.map(item => (
        <div>
          <Subtitle>{item.url}</Subtitle>
          <MuxPlayer
            streamType="on-demand"
            playbackId={item.imagen}
            poster={item.logo}
            style={{ height: '23em' }}
          />
        </div>
      ))}
    </div>
  );
};

export default EventPlayer3;
